import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=6bf1a9f0&"
import script from "./Cases.vue?vue&type=script&lang=ts&"
export * from "./Cases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports